module.exports = __webpack_public_path__ + "img/einvoice-draft-filter.545828b8.svg";